import gql from 'graphql-tag';

export class ActivityPaymentFragment {
    static depositAccount = gql`
        fragment depositAccount on CompteDTO {
            Id
            Libelle
            Numero
            Code
        }`;

    static journal = gql`
        fragment journal on JournalDTO {
            Id
            Code
            Libelle
            TypeBudget
            TypeJournal {
                Code
            }
        }`;

    static iban = gql`
        fragment iban on RibDTO {
            Id
            EstCloture
            CodePays
            CodeBanque
            CleIban
            Iban
            EstRibParDefaut
            ListeRibMandat {
                RibMandatDTO {
                    Id
                    IsClos
                    NumeroReference
                    Rib {
                        Id
                    }
                    CompteBancaire {
                        Id
                    }
                }
            }
        }`;

    static article = gql`
        fragment article on ArticleDTO {
            Id
            Libelle
            PrixPublic
            Produit {
                Id
                Libelle
                Famille {
                    Id
                    Activite {
                        Id
                        CEDelegationProprietaire {
                            Id
                            CEIdcGlob
                        }
                    }
                }
            }
            ListArticleStock {
                StockArticleDTO {
                    Qte
                    Stock {
                        Id
                        PV {
                            CEDelegation {
                                Id
                                CEIdcGlob
                            }
                        }
                    }
                }
            }
        }`;

}
